import { Form, Field, TextInput } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { declarationValidation } from '../../declarationsValidation';

const FIELDS = [
  {
    name: 'biofuelsForTransportSaving',
    labelKey: 'FORM_BIOFUELS_TRANSPORT_SAVING',
    placeholderKey: 'FORM_BIOFUELS_TRANSPORT_SAVING_PLACEHOLDER',
  },
  {
    name: 'bioliquidsElectricitySaving',
    labelKey: 'FORM_BIOLIQUIDS_ELECTRICITY_SAVING',
    placeholderKey: 'FORM_BIOLIQUIDS_ELECTRICITY_SAVING_PLACEHOLDER',
  },
  {
    name: 'biomassOutermostRegionsSaving',
    labelKey: 'FORM_BIOMASS_OUTERMOST_REGIONS_SAVING',
    placeholderKey: 'FORM_BIOMASS_OUTERMOST_REGIONS_SAVING_PLACEHOLDER',
  },
  {
    name: 'bioliquidsHeatSaving',
    labelKey: 'FORM_BIOLIQUIDS_HEAT_SAVING',
    placeholderKey: 'FORM_BIOLIQUIDS_HEAT_SAVING_PLACEHOLDER',
  },
  {
    name: 'biomassCoalSubstitutionSaving',
    labelKey: 'FORM_BIOMASS_COAL_SUBSTITUTION_SAVING',
    placeholderKey: 'FORM_BIOMASS_COAL_SUBSTITUTION_SAVING_PLACEHOLDER',
  },
];

// GhgEmissionSavingSection — Validate Declaration. All 5 fields are full width.
export const GhgEmissionSavingSection = () => {
  const t = useTranslations();

  return (
    <Form.Section title={t('SECTION_GHG_EMISSION_SAVING')}>
      {FIELDS.map((field) => (
        <Form.Row key={field.name} columns={1}>
          <PercentField field={field} />
        </Form.Row>
      ))}
    </Form.Section>
  );
};

const PercentField = ({ field }) => {
  const t = useTranslations();
  const { name, labelKey, placeholderKey } = field;
  return (
    <Field name={name} rules={declarationValidation[name]}>
      {({ id, value, onChange, onBlur, status, message }) => (
        <TextInput
          id={id}
          name={name}
          label={t(labelKey)}
          placeholder={t(placeholderKey)}
          suffix="%"
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
        />
      )}
    </Field>
  );
};
